import { Loader, NoBgLoaderWrapper } from '../PageLoader'

export const AsyncLoaderPage = (
  <NoBgLoaderWrapper className="noscroller">
    <Loader className="loader" />
  </NoBgLoaderWrapper>
)
